export default "__VITE_ASSET__BTMWGUee__"